export const NUMBER_OF_ROWS: number[] = [15, 30, 50];
export const DEFAULT_HEADER_SORT_VALUES = { sortingType: false, selectedColumn: '' };
export const TABLE_CACHE_PREFIX = '__tableSettings';
